export const avatar = 'avatar';
export const menuOpenButton = 'menu_open-button';
